import { onError } from 'apollo-link-error'
import * as authService from '../../services/auth'

const unauthorized = () => {
  authService.onLogout();
  (window || {}).location = '/login'
}

const linkError = (...rest) => {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, extensions }) => {
        if (window.location.pathname === '/login' && !authService.getAccessToken()) return

        // Tratar erros 401 (Unauthorized)
        if (message === '401: Unauthorized' || message === 'Unauthorized') {
          return unauthorized()
        }

        // Tratar erros 500 (Internal Server Error) - não lançar exceção não capturada
        if (message && message.includes('500: Internal Server Error')) {
          console.error('GraphQL 500 Error:', {
            message,
            operation: operation?.operationName,
            variables: operation?.variables,
            extensions
          })
          // Não lançar exceção, apenas logar o erro
          // O erro será tratado pelo componente através do errorPolicy: 'all'
          return
        }

        // Logar outros erros GraphQL sem lançar exceção
        console.error('GraphQL Error:', {
          message,
          extensions,
          operation: operation?.operationName
        })
      })
    }

    // Tratar erros de rede sem lançar exceção não capturada
    if (networkError) {
      console.error('Network Error:', {
        error: networkError,
        operation: operation?.operationName
      })
      // Não lançar exceção para erros de rede, apenas logar
    }
  })
}

export default linkError
